import Vue from 'vue'
import VueRouter from 'vue-router'

import Meta from 'vue-meta'

Vue.use(VueRouter)
Vue.use(Meta)

const routes = [
  { path: '/', name: 'Home', component: () => import(/* webpackChunkName: "home"*/ '../views/Home.vue') },
  { path: '/post', name:'PostList', component:() => import(/* webpackChunkName: "post.list"*/ '../views/Post.vue') },
  { path: '/post/:num', name:'PostView', component:() => import(/* webpackChunkName: "post.view"*/ '../views/PostView.vue') },
  { path: '/txsi', name:'PostView', component:() => import(/* webpackChunkName: "post.view"*/ '../views/Txsi.vue') },
  { path: '*', name: 'Error404', component: () => import(/* webpackChunkName: "error.404" */ '../views/Error/Error404.vue') }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

export default router
